import { envConfigs } from '@config/envConfigs';
import { IDesignBriefSearch } from '@designBrief/designBrief.models';
import { IProjectDesignModificationSearchResult } from '@designModification/designModification.models';
import { IPagedResultsV1 } from '@gcl/react-core';
import { ILoadingRemovalCertSearch } from '@permitToLoadRemove/permitToLoadRemove.models';
import { ITransmittalItem } from '@transmittal/transmittal.models';
import { apiServerGet } from '@common/axios.services';
import { IProjectCertificateSearchResult } from 'src/projectCertificate/projectCertificate.models';
import { IByT1Request } from './DetailPageRightMenu.models';

export const apiRoutes = {
  designBriefsByT1: '/DesignBriefs/ByT1',
  designModificatioinsByT1: '/DesignModifications/ByT1',
  loadingRemovalCertsByT1: '/LoadingRemovalCerts/ByT1',
  designerTransmittalsByT1: '/Transmittals/Designers/ByT1',
  siteTransmittalsByT1: '/Transmittals/Sites/ByT1',
  checkerTransmittalsByT1: '/Transmittals/Checkers/ByT1',
  reviewerTransmittalsByT1: '/Transmittals/Reviewers/ByT1',
  checkCertificateByT1: '/ProjectCertificates/ByT1',
};

const createByT1AsyncFn = <T>(apiRoute: string) => {
  return async (params: IByT1Request): Promise<IPagedResultsV1<T>> => {
    const result = await apiServerGet<IPagedResultsV1<T>>(`${envConfigs.apiBaseUrl}${apiRoute}`, {
      params,
    });
    return result.data;
  };
};

export const getDesignBriefsByT1Async = createByT1AsyncFn<IDesignBriefSearch>(apiRoutes.designBriefsByT1);

export const getDesignModificationsByT1Async = createByT1AsyncFn<IProjectDesignModificationSearchResult>(
  apiRoutes.designModificatioinsByT1,
);

export const getLoadingRemovalCertsByT1Async = createByT1AsyncFn<ILoadingRemovalCertSearch>(
  apiRoutes.loadingRemovalCertsByT1,
);

export const getDesignerTransmittalsByT1Async = createByT1AsyncFn<ITransmittalItem>(apiRoutes.designerTransmittalsByT1);
export const getCheckerTransmittalsByT1Async = createByT1AsyncFn<ITransmittalItem>(apiRoutes.checkerTransmittalsByT1);
export const getSiteTransmittalsByT1Async = createByT1AsyncFn<ITransmittalItem>(apiRoutes.siteTransmittalsByT1);
export const getReviewerTransmittalsByT1Async = createByT1AsyncFn<ITransmittalItem>(apiRoutes.reviewerTransmittalsByT1);
export const getCheckCertificatesByT1Async = createByT1AsyncFn<IProjectCertificateSearchResult>(
  apiRoutes.checkCertificateByT1,
);
